import { render, staticRenderFns } from "./Precipitation.vue?vue&type=template&id=67ca09d2&"
import script from "./Precipitation.vue?vue&type=script&lang=js&"
export * from "./Precipitation.vue?vue&type=script&lang=js&"
import style0 from "./Precipitation.vue?vue&type=style&index=0&id=67ca09d2&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports